var _rect, _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAngleIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 12,
    fill: "#FEF2F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_421_9948)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.9999 18.6667H37.3333V14.6667H33.3333V16.008L14.6666 11.2813V9.33334H10.6666V13.3333H11.9999V21.3333H9.33325V32H11.9999V34.6667H10.6666V38.6667H14.6666V37.3333H33.3333V38.6667H37.3333V34.6667H35.9999V32H38.6666V21.3333H35.9999V18.6667ZM34.6666 16H35.9999V17.3333H34.6666V16ZM11.9999 10.6667H13.3333V12H11.9999V10.6667ZM13.3333 13.3333H14.6666V12.664L33.3333 17.3907V18.6667H34.6666V21.3333H13.3333V13.3333ZM13.3333 37.3333H11.9999V36H13.3333V37.3333ZM35.9999 37.3333H34.6666V36H35.9999V37.3333ZM34.6666 34.6667H33.3333V36H14.6666V34.6667H13.3333V32H34.6666V34.6667ZM37.3333 22.6667V30.6667H35.9999V26.6667H34.6666V30.6667H33.3333V28H31.9999V30.6667H30.6666V24H29.3333V30.6667H27.9999V28H26.6666V30.6667H25.3333V26.6667H23.9999V30.6667H22.6666V28H21.3333V30.6667H19.9999V24H18.6666V30.6667H17.3333V28H15.9999V30.6667H14.6666V26.6667H13.3333V30.6667H10.6666V22.6667H37.3333Z",
    fill: "#E24C4C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_421_9948"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleIcon);
export default __webpack_public_path__ + "static/media/angleIcon.9fa5240451289b48fc7ad30173bdfa35.svg";
export { ForwardRef as ReactComponent };